import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getNotifications,
  getUnreadCount,
  markNotificationAsRead,
  markSelectedNotificationsAsRead,
  markAllNotificationsAsRead,
  type GetNotificationsParams,
} from '../api/notifications.api';

const UNREAD_COUNT_KEY = ['notifications', 'unread-count'];
const LIST_KEY = ['notifications', 'list'];

export function useUnreadNotificationCount() {
  return useQuery({
    queryKey: UNREAD_COUNT_KEY,
    queryFn: getUnreadCount,
    // Cheap poll so the bell badge stays roughly current without a
    // websocket — this app has no push infrastructure yet.
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}

export function useNotificationsList(params: GetNotificationsParams = {}) {
  return useQuery({
    queryKey: [...LIST_KEY, params],
    queryFn: () => getNotifications(params),
    refetchInterval: 30_000,
  });
}

export function useMarkNotificationAsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markNotificationAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LIST_KEY });
      queryClient.invalidateQueries({ queryKey: UNREAD_COUNT_KEY });
    },
  });
}

export function useMarkSelectedNotificationsAsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markSelectedNotificationsAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LIST_KEY });
      queryClient.invalidateQueries({ queryKey: UNREAD_COUNT_KEY });
    },
  });
}

export function useMarkAllNotificationsAsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markAllNotificationsAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LIST_KEY });
      queryClient.invalidateQueries({ queryKey: UNREAD_COUNT_KEY });
    },
  });
}
